import React from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { Button, Icon } from '@fiverr-private/fit';
import { l_arrow_right } from '@fiverr-private/icons';
import CustomOrder from '../../../shared/CustomOrder';
import ContactSellerBtn from '../../ContactSellerBtn';
import { ARROW_SIZE } from '../../constants';
import { COPY_ROOT } from '../constants';

import './style.scss';

const MP_SOURCE_COMPONENT = 'Gig page contact seller options button';
const BQ_SOURCE_NAME = 'contact_seller';
const CUSTOM_ORDER_BQ_SOURCE_NAME = 'contact_seller';

const PopoverContent = () => (
    <>
        <p className="title tbody-5">
            <b><I18n k={`${COPY_ROOT}.popover.title`}/></b>
        </p>
        <CustomOrder bqSourceName={CUSTOM_ORDER_BQ_SOURCE_NAME}>
            <Button>
                <I18n k={`${COPY_ROOT}.popover.get_a_quote`}/>
                <Icon size={ARROW_SIZE}>{l_arrow_right}</Icon>
            </Button>
        </CustomOrder>
        <ContactSellerBtn showArrow
            mixpanelSourceComponent={MP_SOURCE_COMPONENT}
            bqSourceName={BQ_SOURCE_NAME}
            titleKey={`${COPY_ROOT}.popover.contact_seller`}/>
    </>
);

export default PopoverContent;
